import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { PurchaseDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { SimpleChargebeeSubscription, getPlainSelectedPlan } from 'modules/billing/lib/prices'

import PaymentGateway from 'modules/billing/components/PaymentGateway'

type SubscribedFrom = 'hub' | 'custom_hub' | 'personalised_hub' | 'starter_plan' | 'f25_plan'

const getButtonLabel = (subscribedFrom: SubscribedFrom) => {
  if (subscribedFrom === 'f25_plan') {
    return i18n.t('pricing_plans.submit')
  }
  return i18n.t('pricing_plans.submit_button.no_plan')
}

type Props = {
  planConfig: SimpleChargebeeSubscription[]
  subscribedFrom: SubscribedFrom
  disabled?: boolean
}

const BillingInfoButton = ({ planConfig, subscribedFrom, disabled = false }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { data: billingData } = useQuery(PurchaseDocument)

  const handleClick = async () => {
    setIsModalOpen(true)
    track(trackingEvents.billing.upgradePlanStart, {
      selected_plans: getPlainSelectedPlan(planConfig),
      subscribed_from: subscribedFrom
    })
  }

  const isF25Pricing = subscribedFrom === 'f25_plan'
  const customLabel = getButtonLabel(subscribedFrom)
  const buttonType = isF25Pricing ? 'primary' : 'upgrade'
  const canPurchaseSubscription =
    billingData?.billing._policies.subscriptionPurchaseSubscription.can

  return (
    <>
      <Button
        disabled={disabled || !canPurchaseSubscription}
        type={buttonType}
        onClick={handleClick}
      >
        {customLabel}
      </Button>
      {isModalOpen && (
        <PaymentGateway
          planConfig={planConfig}
          onClose={() => setIsModalOpen(false)}
          isF25Pricing={isF25Pricing}
        />
      )}
    </>
  )
}

export default BillingInfoButton
